import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

export const ModelWrapperWithButton = ({ children, ...props }) => {
  const [showeffect, setShowEffect] = useState(false);

  const HandleModelClose = () => {
    if (props?.loader) return;

    setTimeout(() => {
      setShowEffect(false);
    }, 200);

    setTimeout(() => {
      props.onCheckModel(false);
      if (props?.onReload) {
        props?.onReload();
      }
    }, 400);
  };

  useEffect(() => {
    if (props.showModal) {
      setTimeout(() => {
        setShowEffect(true);
      }, 200);
    } else {
      setShowEffect(false);
    }
  }, [props.showModal]);

  return (
    <>
      {props.showModal ? (
        <>
          <div
            className={`justify-center transitioncss ${
              showeffect ? "modeleffect" : "popup"
            } items-center flex ${
              props?.showModal && "overflow-x-hidden overflow-y-auto"
            } fixed inset-0 z-[49] outline-none focus:outline-none`}
          >
            <div className="relative my-6 max-w-8xl w-4/5 h-4/5">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/* HEADER */}
                <div className="flex items-start justify-between p-5 border-b border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold">
                    {props.headertitle}
                  </h3>

                  <button
                    className="p-1 ml-auto text-black text-3xl"
                    onClick={HandleModelClose}
                    disabled={props?.loader}
                  >
                    ×
                  </button>
                </div>

                {/* BODY */}
                <div className="relative p-6 flex-auto">{children}</div>

                {/* FOOTER */}
                {props.nofooter !== true && (
                  <div className="flex items-center justify-end p-6 border-t border-slate-200 rounded-b">
                    {/* CLOSE BUTTON */}
                    <button
                      className="text-red-500 font-bold px-6 outline-none mr-1 mb-1"
                      type="button"
                      onClick={
                        props?.isDelete ? props?.HandleDelete : HandleModelClose
                      }
                      disabled={props?.loader}
                    >
                      {props?.isDelete ? (
                        <FormattedMessage
                          id="POPUP.DELETE.BUTTON"
                          defaultMessage="Delete"
                        />
                      ) : (
                        <FormattedMessage
                          id="POPUP.CLOSE.BUTTON"
                          defaultMessage="Close"
                        />
                      )}
                    </button>

                    {/* SAVE BUTTON */}
                    {props?.hideSaveButton !== true && (
                      <button
                        className={`${
                          props?.color
                            ? props?.color
                            : "bg-[#ff39b3] text-white"
                        } font-bold py-2.5 px-6 rounded-lg shadow outline-none mr-1 mb-1 transition-all duration-150 ${
                          props?.loader
                            ? "opacity-60 cursor-not-allowed"
                            : "hover:shadow-lg"
                        }`}
                        type="button"
                        onClick={props.Save}
                        disabled={props?.loader}
                      >
                        {props?.loader ? (
                          <span className="flex items-center gap-2">
                            <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                            Saving...
                          </span>
                        ) : props?.savetext ? (
                          props?.savetext
                        ) : (
                          <FormattedMessage
                            id="POPUP.SAVECHANGES.BUTTON"
                            defaultMessage="SAVE CHANGES"
                          />
                        )}
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {showeffect && (
            <div className="opacity-25 fixed inset-0 z-30 bg-black"></div>
          )}
        </>
      ) : null}
    </>
  );
};
